import { getContentfulSettings, getEntries, isErrorResponse } from '@belong/contentful';
import { logger } from '@belong/logging';
import { IContentfulSettings, IOfferCampaign } from '@belong/types';
import { FOfferCampaign } from './factories';

/**
 * Load campaign content from the CMS for the given campaign codes
 * Some campaignCodes might not have campaigns in the CMS, but we will try to load all of them and return the ones that exist
 */
export async function loadMobileCampaigns(
  correlationId: string,
  contentfulSettings?: IContentfulSettings,
  campaignCodes: string[] = []
): Promise<IOfferCampaign[]> {
  logger.info(correlationId, 'loadMobileCampaigns - Loading campaigns', { campaignCodes });

  // Only load the fields needed for src/overrides, to reduce payload size and improve performance
  // Other overrides will be loaded on demand using useCampaignOverride hook
  const includedFields = [
    'fields.identifier',
    'fields.campaignCode',
    'fields.homepagePrimaryBanner',
    'fields.mobilePlanPageBanner',
    'fields.dataPlanPageBanner'
  ];

  const response = await getEntries(
    {
      content_type: 'offerCampaign',
      'fields.campaignCode[in]': campaignCodes.join(),
      select: includedFields.join(','),
      include: 10
    },
    contentfulSettings ?? getContentfulSettings(),
    correlationId
  );

  if (isErrorResponse(response)) {
    logger.error('loadMobileCampaigns - Failed to load offer campaigns', response);
    return [];
  }

  return response.map(FOfferCampaign);
}
